// @noflow
import * as activePlugs from './active-plugs';
import * as colorTuneableLight from './color-tuneable-light';
import * as colorLight from './color-light';
import * as heating from './heating';
import * as hotWater from './hot-water';
import * as naThermostatCool from './na-thermostat-cool';
import * as naThermostatDual from './na-thermostat-dual';
import * as naThermostatHeat from './na-thermostat-heat';
import * as recipes from './recipes';
import * as tuneableLight from './tuneable-light';
import * as warmWhiteLight from './warm-white-light';

import { scheduleType } from '~/core/constants/schedule';
import theme from '~/core/themes/main';

const getTypeBehaviour = type =>
    ({
        [true]: {},
        [type === scheduleType.ACTIVE_PLUG]: activePlugs,
        [type === scheduleType.COLOUR_TUNEABLE_LIGHT]: colorTuneableLight,
        [type === scheduleType.COLOUR_LIGHT]: colorLight,
        [type === scheduleType.HEATING]: heating,
        [type === scheduleType.HOT_WATER]: hotWater,
        [type === scheduleType.NA_THERMOSTAT_COOL]: naThermostatCool,
        [type === scheduleType.NA_THERMOSTAT_DUAL]: naThermostatDual,
        [type === scheduleType.NA_THERMOSTAT_HEAT]: naThermostatHeat,
        [type === scheduleType.RECIPE]: recipes,
        [type === scheduleType.TUNEABLE_LIGHT]: tuneableLight,
        [type === scheduleType.WARM_WHITE_LIGHT]: warmWhiteLight
    }[true]);

export const getDefaultEventValue = args => {
    const { type } = args;
    const { defaultEventValue } = getTypeBehaviour(type);
    return defaultEventValue;
};

export const getValueColor = args => {
    const { slotType } = args;
    const defaultColor = theme.mediumGrey;
    const { getValueColor } = getTypeBehaviour(slotType);

    return getValueColor ? getValueColor(args) : defaultColor;
};

export const getDualColors = args => {
    const { type } = args;
    const defaultDualColors = null;
    const { getDualColors } = getTypeBehaviour(type);
    return getDualColors ? getDualColors(args) : defaultDualColors;
};

export const getValueLabel = args => {
    const { slotType } = args;
    const defaultLabel = '';
    const { getValueLabel } = getTypeBehaviour(slotType);

    return getValueLabel ? getValueLabel(args) : defaultLabel;
};

export const updateValue = (type, event) => {
    const { updateValue } = getTypeBehaviour(type);
    if (updateValue) {
        return updateValue(event);
    } else {
        // eslint-disable-next-line no-console
        console.warn(`No 'updateValue' function was defined for this schedule type! ${type}`);
        return event;
    }
};

export const hasPicker = args => {
    const { type } = args;
    const defaultValue = false;
    const { hasPicker } = getTypeBehaviour(type);
    return hasPicker ? hasPicker(args) : defaultValue;
};

export const getPicker = args => {
    const { type } = args;
    const { getPicker } = getTypeBehaviour(type);
    if (getPicker) {
        return getPicker(args);
    } else {
        // eslint-disable-next-line no-console
        console.warn(`No 'getPicker' function was defined for this schedule type! ${type}`);
        return null;
    }
};

export const hasSaveButton = args => {
    const { type } = args;
    const defaultValue = true;
    const { hasSaveButton } = getTypeBehaviour(type);
    return hasSaveButton ? hasSaveButton(args) : defaultValue;
};

export const getDefaultSchedule = args => {
    const { type } = args;
    const { getDefaultSchedule } = getTypeBehaviour(type);
    if (getDefaultSchedule) {
        return getDefaultSchedule(args);
    } else {
        // eslint-disable-next-line no-console
        console.warn(`No 'getDefaultSchedule' function was defined for this schedule type! ${type}`);
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/index.js